import CommonMobileNumber from "@components/mobilenumber/MobileNumber";
import styles from "./MobileNoLogin.module.css";
import LoginIllustration from "@assets/images/login-illustration.svg";
import LoginTopImg from "@assets/images/login-top-image.svg";
import LoginBottomImg from "@assets/images/login-bottom-image.svg";
import SendOtp from "@modals/sendotp/SendOtp";
import VerifyOtp from "@modals/verifyotp/VerifyOtp";
import EditPhoneNumber from "@modals/editphonenumber/EditPhoneNumber";
import LoginWithPassword from "@modals/loginwithpassword/LoginWithPassword";
import Header from "@components/header/Header";
import { motion } from "motion/react";
import { useLoginModals } from "@hooks/login";

function MobileNoLogin() {
  const { activeModal, closeModal } = useLoginModals();

  const renderComponent = () => {
    switch (activeModal) {
      case "SendOtp":
        return <SendOtp isOpen={true} onClose={closeModal} />;
      case "VerifyOtp":
        return <VerifyOtp isOpen={true} onClose={closeModal} />;
      case "EditPhoneNumber":
        return <EditPhoneNumber isOpen={true} onClose={closeModal} />;
      case "LoginWithPassword":
        return <LoginWithPassword isOpen={true} onClose={closeModal} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <motion.div
        className={styles.loginContainer}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <motion.img
          src={LoginTopImg}
          alt="Top background"
          className={styles.topImage}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
        <motion.img
          src={LoginBottomImg}
          alt="Bottom background"
          className={styles.bottomImage}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
        />

        <div className={styles.leftSection}>
          <motion.h1
            className={styles.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          >
            <motion.span
              style={{ display: "block" }}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              Welcome to
            </motion.span>
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              SUBJECTIVE ASSESSMENT
              <br />
              EVALUATOR PORTAL
            </motion.span>
          </motion.h1>

          <motion.div
            className={styles.loginForm}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.5 }}
          >
            <CommonMobileNumber />
          </motion.div>
        </div>

        <div className={styles.rightSection}>
          <motion.img
            src={LoginIllustration}
            alt="Login Illustration"
            className={styles.mainImage}
            initial={{
              opacity: 0,
              scale: 0.5,
              rotate: -25,
              y: 50,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              rotate: 0,
              y: 0,
            }}
            transition={{
              duration: 1,
              ease: [0.34, 1.56, 0.64, 1],
              delay: 0.6,
            }}
          />
        </div>
        {renderComponent()}
      </motion.div>
    </>
  );
}

export default MobileNoLogin;
